export interface PopinSuppressionModel {
	id: string
	open: boolean,
	procedureId: string
}
export const INITIAL_SUPPRESSION_PROCEDUREE_POPIN: PopinSuppressionModel = {
	id: 'suppression_procedure',
	open: false,
	procedureId: ''
}